/**
 *  Main
 *
 *  Created by Legman on 19/9/2015.
 *
 */

import Application      from "./Application";
import AudioManager     from "./AudioManager";
import Common           from "./Common";
import PreloaderScene   from "./PreloaderScene";
//import Physics          from "./Physics";

export default class Main {
    /**
     * @param {number} width
     * @param {number} height
     */
    constructor(width, height) {
        /**
         * @member {!number}
         * @private
         */
        this._width = width;

        /**
         * @member {!number}
         * @private
         */
        this._height = height;

        /**
         * @member {PreloaderScene}
         * @private
         */
        this._preloader = null;

        /**
         * @member {Application}
         * @private
         */
        this._game = null;

        /**
         * so can start game from preloader button
         * @type {Main.startGame}
         */
        window.startGame = this.startGame;
    }

    init() {

        Common.assets = p3.AssetManager.instance;
        Common.audio = p3.Button.audio = new AudioManager();
        Common.language = language;

        // Common.physics = new Physics();
        Common.loadGame();

        const params = new p3.ViewParams();
        params.holderId = "game";
        params.width = this._width;
        params.height = this._height;
        //  params.portrait = true;
        ///params.aspectRatioFillHeight = false;
        params.rotateImageUrl = "./assets/images/localisation/rotate_" + Common.language + ".jpg";
        params.rotateImageColor = "#000000";

        PIXI.settings.RETINA_PREFIX = /\_(?=[^_]*$)(.+)x/;
        PIXI.settings.MIPMAP_TEXTURES = false;

        p3.Device.init(window["bowser"]);

        TweenMax.defaultOverwrite = "none";
        TweenMax.ticker.fps(60);

        const view = new p3.View(params);
        view.signals.ready.addOnce(function (canvas) {
            const options = {};
            options.view = canvas;
            options.transparent = false;
            options.antialias = false;
            options.preserveDrawingBuffer = false;
            options.resolution = 1.0;

            const stage = new PIXI.Container();
            Common.stage = stage;

            //const input = new Input();
            //input.init(stage, canvas);
            //Common.input = input;

            //on clicking the document focus on canvas, fix for buttons not working on mobile
            document.onclick = () => {
                canvas.focus();
            };

            if (p3.Device.isCocoonJS) {
                stage.scale.x = window.innerHeight / params.height;
                stage.scale.y = window.innerHeight / params.height;
            }

            const renderer = !p3.Device.isCocoonJS ?
                PIXI.autoDetectRenderer(this._width, this._height, options) :
                new PIXI.WebGLRenderer(window.innerWidth, window.innerHeight, options);
            renderer.backgroundColor = 0x000000;
            Common.renderer = renderer;
            Common.isWebGL = (renderer instanceof PIXI.WebGLRenderer);

            const scene = new p3.SceneManager(renderer);
            scene.updateAll = true;
            Common.scene = scene;
            Common.stage.addChild(scene.view);

            PIXI.ticker.shared.add(function (deltaTime) {

                window.deltaTime = deltaTime / PIXI.settings.TARGET_FPMS / 1000;

                renderer.render(Common.stage);
                scene.update();

            }, this);

            /*
             const timestep = new p3.Timestep(p3.Timestep.FIXED);
             timestep.init(this.update, this.render, this);
             Common.timestep = timestep;
             */

            window.delay = function (callback, delay, scope) {
                //return Common.animator.setTimeout(callback, delay, scope);
                TweenMax.delayedCall(delay, callback, [], scope);
            };
            window.translate = function (str) {
                let s = Common.config.strings[str];
                s = s && s[Common.language];
                return (typeof s !== "undefined") ? s : str;
            };

            this.loadPreloader();
        }, this);
        view.signals.resize.add(this.onCanvasResize, this);
        Common.view = view;
    }

    loadPreloader() {
        const files = [
            {name: "preloader", url: "images/" + "preloader" + ".json"}
        ];

        if(Common.language == 'es')
        {
            files.push({name: "preloader_es", url: "images/localisation/preloader_es.png"});
            files.push({name: "preloader_overlay_es", url: "images/preloader_overlay_es.png"});
        }

        const sounds = [];
        if (files.length) {
            Common.assets.addFiles(files, "assets/");
            Common.assets.signals.complete.addOnce(function () {
                this.createConfig();
                this.loadAssets();
            }, this);
            Common.assets.load();
            Common.audio.addSounds(sounds, [".mp3", ".ogg"], "");
        } else {
            this.loadAssets();
        }
    }

    loadAssets() {
        const files = [
            //jpeg
            {name: "bg", url: "images/" + "bg" + ".jpg"},
            //spine
            {name: "stunt_happo_flying", url: "images/" + "stunt_happo_flying" + ".json"},
            {name: "stunt_happo_standing", url: "images/" + "stunt_happo_standing" + ".json"},
            {name: "alien", url: "images/" + "alien" + ".json"},
            {name: "tutorial", url: "images/" + "tutorial" + ".json"},
            //png
            {name: "particle", url: "images/" + "particle" + ".png"},
            //  {name: "finger", url: "images/" + "finger" + ".png"},
            //temp single textures
            //   {name: "ground", url: "images/" + "ground" + ".png"},
            ///    {name: "mid_ground", url: "images/" + "mid_ground" + ".png"},
            ///    {name: "mid_ground_2", url: "images/" + "mid_ground_2" + ".png"},
            //     {name: "mountains_bg", url: "images/" + "mountains_bg" + ".png"},
            //sheets
            {name: "ui_1x_0", url: "images/" + "ui_1x_0" + ".json"},
            // {name: "ui_1x_1", url: "images/" + "ui_1x_1" + ".json"},
            {name: "ingame_1x_0", url: "images/" + "ingame_1x_0" + ".json"},
            {name: "ingame_1x_1", url: "images/" + "ingame_1x_1" + ".json"},
            {name: "bg_assets_1x", url: "images/" + "bg_assets_1x" + ".json"},
            //fonts
            {name: "titles", url: "fonts/" + "titles" + ".xml"},
            {name: "copyFoo", url: "fonts/" + "copy" + ".xml"},
            //data
            {name: "copy", url: "data/" + "copy" + ".json"},
            //{name: "config", url: "data/" + "config" + ".json"},
            //particles
            {name: "particles_gameover", url: "particles/" + "particles_gameover" + ".json"},
            {name: "particles_dust_ground", url: "particles/" + "particles_dust_ground" + ".json"},
            {name: "particles_character_boost_ready", url: "particles/" + "particles_character_boost_ready" + ".json"},
            {
                name: "particle_cannon_directional_blast",
                url: "particles/" + "particle_cannon_directional_blast" + ".json"
            },
            {name: "particles_splash_mud", url: "particles/" + "particles_splash_mud" + ".json"},
            {name: "particles_splash_water", url: "particles/" + "particles_splash_water" + ".json"},
            {name: "particles_cannon_1", url: "particles/" + "particles_cannon_1" + ".json"},
            {name: "particles_cannon_2", url: "particles/" + "particles_cannon_2" + ".json"},
            {name: "particles_pickup", url: "particles/" + "particles_pickup" + ".json"},
            {name: "particles_boostmeter", url: "particles/" + "particles_boostmeter" + ".json"},
            {name: "particles_boost", url: "particles/" + "particles_boost" + ".json"}
        ];

        const sounds = [
            "sfx_btn_press_00",
            "sfx_btn_rollover_00",

            // "sfx_bounce_placeholder",
            "music_mainmenu_loop_00",
            "music_ready_loop_012",

            "music_results_short_00",
            "music_results_long_00",

            //sfx in game
            "sfx_happo_crash_00",

            "sfx_happo_fling_00",
            "sfx_happo_fling_01",
            "sfx_bounce_big_00",
            "sfx_bounce_bonus_00",

            "sfx_happos_ooh_00",
            "sfx_happos_cheer_00",
            "sfx_happo_impact_00",

            "sfx_cannon_fire_00",
            "sfx_cannon_fire_01",

            "sfx_cannon_move_00",
            "sfx_cannon_move_01",
            "sfx_cannon_move_02",

            "sfx_bounce_bucket_00",
            "sfx_bounce_drum_00",
            "sfx_bounce_fear_00",
            "sfx_bounce_hammock_00",
            "sfx_bounce_metal_00",
            "sfx_bounce_plastic_00",
            "sfx_bounce_springboard_00",
            "sfx_bounce_trampoline_00",
            "sfx_bounce_yogaball_00",

            "sfx_happo_ok_00",

            "sfx_star_jump_ready_00",
            "sfx_star_pickup_00",

            "sfx_bounce_puddle_00",
            "sfx_bounce_mud_00",

            "sfx_ambient_desert_loop_00"
        ];
        if (files.length) {
            this._preloader = new PreloaderScene();
            Common.scene.add(this._preloader);

            Common.assets.addFiles(files, "assets/");
            Common.assets.signals.progress.add(this.onLoadingProgress, this);
            Common.assets.signals.complete.addOnce(this.onLoadingCompleted, this);
            Common.assets.load();
            Common.audio.addSounds(sounds, [".m4a", ".mp3", ".ogg"], "assets/audio/");
        } else {
            this.startGame();
        }
    }

    createConfig() {
        const assets = Common.assets;
        const config = {};
        Common.config = config;
    }

    startGame() {
        delay(function () {
            this._game = new Application();
            this._game.init();
        }, 1.0, this);
    }

    onLoadingProgress(event) {
        this._preloader.loaded = event.progress / 100.0;
    }

    onLoadingCompleted() {
        Common.assets.signals.progress.removeAll();
        Common.assets.signals.complete.removeAll();

        this._preloader.loaded = 1;
        this.startGame();
    }

    /**
     * @param {boolean} correct
     */
    onCanvasResize(correct) {
        if (correct) {
            Common.renderer.resize(p3.View.width, p3.View.height);
            if (Common.scene) {
                Common.scene.resize();
            }
        }
    }
}

/**
 *
 * @param copy
 * @param fontName
 * @param size
 * @param holder
 * @param colour
 * @returns {PIXI.Text}
 */
function createText(copy, fontName, size, holder, colour) {
    const col = colour | 0x000000;
    const textView = new PIXI.Text(copy, {fontFamily: fontName, fontSize: size, fill: col});
    textView.anchor.x = 0.5;
    if (holder) holder.addChild(textView);
    //Common.displayObjs.push(textView);
    return textView;
}
window.p3.simpleText = createText;

window.Main = Main;
